import { useAccountLimit } from "../../../../generic/hooks/use-account-limit";
import type { ListenEntitlement } from "../../../../generic/server/supabase-account-service";
import { useLexicalContext } from "../../lexical-context";

/**
 *
 * @returns A boolean which indicates that surveys are used in either pro or basic (they are
 * not discerned between the two here) and that the editor is not in a toChannel mode.
 */
export function useSurveysEnabledLexical(listenEntitlement?: ListenEntitlement | null):
  | {
      enabled: false;
    }
  | { enabled: true; type: "channel" | "individual" } {
  const { data } = useAccountLimit("listen_entitlement");
  listenEntitlement = listenEntitlement || data;
  const { toChannel } = useLexicalContext();

  if (!["Pro", "Basic"].includes(listenEntitlement || "")) {
    return { enabled: false };
  }

  return { enabled: true, type: toChannel ? "channel" : "individual" };
}
